import React from "react";
import USKbvMatchMinute from "../USKbvMatchMinute";
import { DesktopOddCell, Desktop1x2Cell } from "./USMatchOddsCell";

export default function USMatchDesktop({
  isLive,
  match,
  statusNum,
  liveScore,
  matchTimeText,
  matchDate,
  homeLogo,
  awayLogo,
  handicapValue,
  homeHandicapOdds,
  homeHandicapTrend,
  handicapHalfValue,
  homeHandicapHalfOdds,
  homeHandicapHalfTrend,
  awayHandicapOdds,
  awayHandicapTrend,
  awayHandicapHalfOdds,
  awayHandicapHalfTrend,
  overUnderValue,
  overOdds,
  overTrend,
  overUnderHalfValue,
  overHalfOdds,
  overHalfTrend,
  underOdds,
  underTrend,
  underHalfOdds,
  underHalfTrend,
  homeEuropeOdds,
  homeEuropeTrend,
  homeEuropeHalfOdds,
  homeEuropeHalfTrend,
  instantDrawOdds,
  drawTrend,
  drawHalfOdds,
  drawHalfTrend,
  awayEuropeOdds,
  awayEuropeTrend,
  awayEuropeHalfOdds,
  awayEuropeHalfTrend,
  OtherBetsButton,
  TipsAiButton,
  currentHomeScore,
  currentAwayScore,
}) {
  return (
    <div className="hidden lg:block">
      <div className="flex flex-col rounded-2xl bg-[var(--theme-bg)] p-2">
        <div className="flex justify-between">
          <div className="flex flex-col justify-between">
            <div className="mb-[6px] flex items-center gap-1">
              <div className="text-[16px] font-semibold leading-[1.5] text-[var(--theme-text)]">
                {isLive ? (
                  <USKbvMatchMinute
                    matchTime={match?.matchTime}
                    status={statusNum}
                    liveScore={liveScore}
                    halfStartTime={match?.halfStartTime}
                    className="frost-text-trend-up"
                  />
                ) : (
                  matchTimeText
                )}
              </div>
              <div className="w-[90px] text-center text-[14px] font-normal leading-[1.57] frost-text-label-muted">
                {matchDate}
              </div>
            </div>

            <div className="flex min-w-0 items-center justify-between gap-3">
              <div className="flex items-center">
                <div className="relative mr-[-16px]">
                  <div className="flex h-[32px] w-[32px] items-center justify-center rounded-[32px] bg-[var(--theme-text)] p-[4px]">
                    <img
                      className="h-full w-full rounded-full object-contain"
                      src={homeLogo || ""}
                      alt={match?.homeName}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <div>
                  <div className="flex h-[32px] w-[32px] items-center justify-center rounded-[32px] bg-[var(--theme-text)] p-[4px]">
                    <img
                      className="h-full w-full rounded-full object-contain"
                      src={awayLogo || ""}
                      alt={match?.awayName}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>

              <div className="flex w-[200px] min-w-0 items-center justify-between">
                <div className="flex min-w-0 flex-1 flex-col gap-2">
                  <div className="truncate text-[16px] font-semibold leading-[1.5] text-[var(--theme-text)]">
                    {match?.homeName}
                  </div>
                  <div className="truncate text-[16px] font-semibold leading-[1.5] text-[var(--theme-text)]">
                    {match?.awayName}
                  </div>
                </div>
                {(currentHomeScore !== null && currentAwayScore !== null) && (
                  <div className="flex flex-col gap-2 pl-2 text-right text-[16px] font-bold text-[var(--theme-text)]">
                    <div>{currentHomeScore}</div>
                    <div>{currentAwayScore}</div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="relative flex items-center gap-3">
            <div className="absolute left-[-46px] top-[calc(50%+12px)] h-[72px] w-px -translate-y-1/2 border-l-[1.5px] border-l-dashed border-l-[var(--theme-btn-border)]" />

            <div>
              <div className="mb-1 text-center text-[14px] font-normal leading-[1.5] frost-text-label-muted">
                Chấp
              </div>
              <div className="inline-grid gap-2 [grid-template-columns:repeat(2,80px)]">
                <div className="flex flex-col gap-3">
                  <DesktopOddCell
                    top={handicapValue}
                    bottom={homeHandicapOdds}
                    trendBottom={homeHandicapTrend}
                  />
                  <DesktopOddCell
                    top={handicapHalfValue}
                    bottom={homeHandicapHalfOdds}
                    trendBottom={homeHandicapHalfTrend}
                  />
                </div>
                <div className="flex flex-col gap-3">
                  <DesktopOddCell
                    top={null}
                    bottom={awayHandicapOdds}
                    trendBottom={awayHandicapTrend}
                  />
                  <DesktopOddCell
                    top={null}
                    bottom={awayHandicapHalfOdds}
                    trendBottom={awayHandicapHalfTrend}
                  />
                </div>
              </div>
            </div>

            <div>
              <div className="mb-1 text-center text-[14px] font-normal leading-[1.5] frost-text-label-muted">
                Tài xỉu
              </div>
              <div className="inline-grid gap-2 [grid-template-columns:repeat(2,80px)]">
                <div className="flex flex-col gap-3">
                  <DesktopOddCell
                    top={overUnderValue}
                    bottom={overOdds}
                    trendBottom={overTrend}
                  />
                  <DesktopOddCell
                    top={overUnderHalfValue}
                    bottom={overHalfOdds}
                    trendBottom={overHalfTrend}
                  />
                </div>
                <div className="flex flex-col gap-3">
                  <DesktopOddCell top="u" bottom={underOdds} trendBottom={underTrend} />
                  <DesktopOddCell top="u" bottom={underHalfOdds} trendBottom={underHalfTrend} />
                </div>
              </div>
            </div>

            <div className="w-[264px] shrink-0">
              <div className="mb-1 flex w-full items-center justify-center text-[14px] font-normal leading-[1.5] frost-text-label-muted">
                1X2
              </div>
              <div className="inline-grid gap-3 [grid-template-columns:repeat(3,80px)]">
                <div className="flex flex-col gap-3">
                  <Desktop1x2Cell
                    label="H"
                    bottom={homeEuropeOdds}
                    trendBottom={homeEuropeTrend}
                  />
                  <Desktop1x2Cell
                    label="H"
                    bottom={homeEuropeHalfOdds}
                    trendBottom={homeEuropeHalfTrend}
                  />
                </div>
                <div className="flex flex-col gap-3">
                  <Desktop1x2Cell label="D" bottom={instantDrawOdds} trendBottom={drawTrend} />
                  <Desktop1x2Cell label="D" bottom={drawHalfOdds} trendBottom={drawHalfTrend} />
                </div>
                <div className="flex flex-col gap-3">
                  <Desktop1x2Cell
                    label="A"
                    bottom={awayEuropeOdds}
                    trendBottom={awayEuropeTrend}
                  />
                  <Desktop1x2Cell
                    label="A"
                    bottom={awayEuropeHalfOdds}
                    trendBottom={awayEuropeHalfTrend}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3 flex justify-end gap-2">
          <OtherBetsButton className="frost-shadow-cta inline-flex h-10 w-[147px] items-center justify-center gap-2 rounded-xl bg-[linear-gradient(-45deg,var(--theme-primary),var(--theme-highlight))] px-3 text-[14px] font-semibold text-[var(--theme-text)] transition hover:-translate-y-[1px] hover:border hover:border-[var(--theme-text)]" />
          <TipsAiButton className="h-10 rounded-xl px-4 text-[14px] [background:linear-gradient(-45deg,#3b82f6,#8b5cf6)] border-none hover:brightness-110" />
        </div>
      </div>
    </div>
  );
}
